// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--APjxm","result":"result--lQPJd"};